import {RouteConfig} from 'vue-router/types/router';
import {NavigationDrawerAccess} from '@/enums/_common/NavigationDrawerAccess.enum';

/**
 * Routes of the online make-up rounds ("Nachholrunde online", Saturday). The planner views also check the custom key
 * MANAGE_MAKEUP_ROUNDS (like the backend). Distinct by segment count: /makeup-rounds/:roundId (planning) vs
 * /makeup-rounds/:roundId/:claimId (legacy public yes-page of a round) vs /makeup-rounds/i/:invitationId/:claimId (public
 * yes-page of an invitation, no login); /makeup-invitations/:invitationId = office view of an invitation.
 */
export const makeupRoundRoutes: RouteConfig[] = [
    {
        path: '/makeup-rounds',
        name: 'Nachholrunden online',
        component: () => import(/* webpackChunkName: "makeup-rounds" */ '@/views/makeup/MakeupRoundsView.vue'),
        meta: {guiAccess: [NavigationDrawerAccess.MAKEUP_ROUNDS]},
    },
    {
        path: '/makeup-rounds/:roundId',
        name: 'Nachholrunde online',
        component: () => import(/* webpackChunkName: "makeup-rounds" */ '@/views/makeup/MakeupRoundView.vue'),
        meta: {guiAccess: [NavigationDrawerAccess.MAKEUP_ROUNDS]},
    },
    {
        path: '/makeup-invitations/:invitationId',
        name: 'Einladung Nachholrunde online',
        component: () => import(/* webpackChunkName: "makeup-rounds" */ '@/views/makeup/MakeupInvitationView.vue'),
        meta: {guiAccess: [NavigationDrawerAccess.MAKEUP_ROUNDS]},
    },
    {
        // public yes-page of an invitation ("Einladung zuerst", 2026-11-03); below /makeup-rounds/ because the WhatsApp URL
        // button of the invitation template is registered at Meta as <CLIENT_URL>/#/makeup-rounds/{{1}}
        path: '/makeup-rounds/i/:invitationId/:claimId',
        name: 'Online-Nachholtermin wählen',
        component: () => import(/* webpackChunkName: "makeup-round-public" */ '@/views/public/MakeupInvitationReplyView.vue'),
        meta: {
            forAll: true,
            answerPage: true,
            hideNavbar: true,
        },
    },
    {
        path: '/makeup-rounds/:roundId/:claimId',
        name: 'Online-Nachholtermin',
        component: () => import(/* webpackChunkName: "makeup-round-public" */ '@/views/public/MakeupRoundReplyView.vue'),
        meta: {
            forAll: true,
            answerPage: true,
            hideNavbar: true,
        },
    },
];
